<template>
    <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title">{{ isEdit ? 'Update Supplier' : 'Buat Supplier' }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>

        <div class="modal-body p-3">
            <div class="form-group">
                <label>Kode</label>
                <input v-model="form.code" type="text" name="code" class="form-control">
                <span class="text-danger">{{ errors.first('code') }}</span>
            </div>
            <div class="form-group">
                <label>Nama</label>
                <input v-validate="'required'" v-model="form.name" type="text" name="name" class="form-control">
                <span class="text-danger">{{ errors.first('name') }}</span>
            </div>
            <div class="form-group">
                <label class="form-control-label">Gudang</label>
                <div class="input-group mb-0 d-flex">
                    <multiselect :class="'w-auto flex-grow-1'" name="gudang" v-model="form.gudang" :options="gudangOptions" :placeholder="'Pilih gudang'" :searchable="true"
                        label="name" track-by="id" :show-labels="false"></multiselect>
                    <div class="input-group-append">
                        <button class="btn btn-primary" type="button" @click="selectGudang = true"><i class="fas fa-search"></i> Pilih</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button @click="save" type="button" class="btn btn-primary">Simpan</button>
            <button @click="$emit('cancel')" type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
        </div>

        <b-modal v-model="selectGudang" size="lg" :hide-header="true" :hide-footer="true">
            <gudang-selector :selected="gudangOptions" @selected="gudangSelected" @cancel="selectGudang = false"></gudang-selector>
        </b-modal>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import GudangSelector from '../gudangs/Selector';

export default {
    name: "suppliers-form",

    props: {
        isEdit: {
            type: Boolean,
            default: false,
        },

        value: {
            type: Object,
            default: () => {},
        }
    },

    components: {
        Multiselect,
        GudangSelector,
    },

    data() {
        return {
            form: null,
            selectGudang: false,
            gudangOptions: [],
        }
    },

    created() {
        this.resetForm();
    },

    mounted() {
        if (this.isEdit) {
            this.initForm();
        }
    },

    computed: {
    },

    watch: {
        value() {
            this.initForm();
        }
    },

    methods: {
        initForm() {
            this.form = Object.assign({}, this.value);
            this.form.gudang = this.form.gudang ? Object.assign({}, this.form.gudang.gudang) : null;
            if (this.form.gudang) {
                this.gudangOptions.push(Object.assign({}, this.form.gudang));
            }
        },

        resetForm() {
            this.form = Object.assign({}, {
                form: {
                    id: '',
                    code: '',
                    name: '',
                    gudang: null,
                }
            });
        },

        save() {
            let self = this;

            self.$validator.validateAll().then(result => {
                if (result) {
                    self._save();
                }
            });
        },

        _save() {
            let self = this;

            let data = {
                code: self.form.code,
                name: self.form.name,
                gudang_ids: self.form.gudang ? [self.form.gudang.id] : [],
            }

            self.$Progress.start();
            axios({
                method: self.isEdit ? 'put' : 'post',
                url: self.isEdit ? '/api/suppliers/'+self.form.id : '/api/suppliers',
                data: data
            })
            .then(function (response) {
                Toast.fire({
                    icon: 'success',
                    title: response.data.message
                });
                self.$Progress.finish();
                self.resetForm();
                self.$emit('saved');
            })
            .catch(function (error) {
                self.requestFailed(error);
            });
        },

        gudangSelected(gudang) {
            let self = this;

            self.gudangOptions.push(gudang);
            self.form.gudang = Object.assign({}, gudang);
            self.selectGudang = false;
        },
    },
}
</script>
